// Bileli · modules/account/model — the user's gamification aggregates (GET /me/stats: XP + streaks;
// always 200, zeroes if the user never practiced). Levels don't exist server-side — levelOf() derives one
// client-side from raw XP so the profile/congrats UI can show progress.

import { bileliApiJson, parseApi, schemas } from '../../../shared';

export interface MyStats {
  currentStreak: number;
  longestStreak: number;
  totalXp: number;
  lastStreakDay?: string | null;
}

export async function fetchMyStats(): Promise<MyStats> {
  const raw = await bileliApiJson<unknown>('/me/stats');
  return parseApi(schemas.UserStatsSchema, raw, 'GET /me/stats');
}

/** XP per level — a flat curve is enough while XP only comes from practice (+10/+20 per attempt). */
export const XP_PER_LEVEL = 500;

export interface LevelInfo {
  level: number; // 1-based
  intoLevel: number; // XP earned inside the current level
  toNext: number; // XP still needed for the next level
  pct: number; // 0..100 progress inside the current level
}

export function levelOf(totalXp: number): LevelInfo {
  const xp = Math.max(0, Math.floor(totalXp));
  const level = Math.floor(xp / XP_PER_LEVEL) + 1;
  const intoLevel = xp % XP_PER_LEVEL;
  return {
    level,
    intoLevel,
    toNext: XP_PER_LEVEL - intoLevel,
    pct: Math.round((intoLevel / XP_PER_LEVEL) * 100),
  };
}
